import { render, staticRenderFns } from "./file-template.vue?vue&type=template&id=6b19eb02&scoped=true&"
import script from "./file-template.vue?vue&type=script&lang=js&"
export * from "./file-template.vue?vue&type=script&lang=js&"
import style0 from "./file-template.vue?vue&type=style&index=0&id=6b19eb02&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b19eb02",
  null
  
)

export default component.exports